import { Fragment } from "react";

import { Outlet } from "react-router-dom";

import Header from "./header/Header";
import Footer from "./footer/Footer";
import PageSeoHead from "../common/PageSeoHead";

const Layout = () => {
  return (
    <Fragment>
      <PageSeoHead />
      <Header />
      <Outlet />
      <Footer />
    </Fragment>
  );
};

export default Layout;
